import { SELECT_NEAREST_MFC } from '../constants';

const initialState = null;

const mfcReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_NEAREST_MFC:
      return action.payload;
    default:
      return state;
  }
};

export default mfcReducer;
